import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { DropdownFilter, FloatInput } from "src/componentes";
import { ConsultaMunicipioModule } from "src/hook/Consulta/ConsultaMunicipio.Module";
import { MunicipioDto } from "src/pages/Privada/Entidade/Municipio/Municipio.Dto";
import { CTeDto, getLocal, STORAGECTE_KEY, updateLocal } from "../CTe.Dto";
import { PercursoFormType, PercursoSchema } from "./CTe.Cadastro.Dto";

const CTeCadastroPercursoView = () => {
  const navigate = useNavigate();
  const consultaMunicipioInicio = ConsultaMunicipioModule();
  const consultaMunicipioFim = ConsultaMunicipioModule();
  const cte = getLocal<CTeDto>(STORAGECTE_KEY);

  const form = useForm<PercursoFormType>({
    resolver: yupResolver(PercursoSchema),
    defaultValues: {
      codigoMunicipioInicio: cte?.codigoMunicipioInicio ?? 0,
      nomeMunicipioInicio: cte?.nomeMunicipioInicio ?? "",
      ufInicio: cte?.ufInicio ?? "",
      codigoMunicipioFim: cte?.codigoMunicipioFim ?? 0,
      nomeMunicipioFim: cte?.nomeMunicipioFim ?? "",
      ufFim: cte?.ufFim ?? "",
    },
  });

  const handleVoltar = () => {
    navigate("../caracteristicas");
  };

  const onSubmit = (data: PercursoFormType) => {
    updateLocal<CTeDto>(STORAGECTE_KEY, {
      codigoMunicipioInicio: Number(data.codigoMunicipioInicio),
      nomeMunicipioInicio: data.nomeMunicipioInicio,
      ufInicio: data.ufInicio,
      codigoMunicipioFim: Number(data.codigoMunicipioFim),
      nomeMunicipioFim: data.nomeMunicipioFim,
      ufFim: data.ufFim,
    });

    navigate("../tributacao");
  };

  return (
    <Form noValidate onSubmit={form.handleSubmit(onSubmit)} className="mt-3 mb-5">
      <div className="mb-4">
        <h5 className="mb-3 text-primary">Início da Prestação</h5>
        <Row className="g-3">
          <Col xs={12} md={9}>
            <DropdownFilter<MunicipioDto>
              fetchData={consultaMunicipioInicio.MunicipioBuscar}
              loading={consultaMunicipioInicio.loading}
              labelDescription="Município de Início"
              getDescription={(item: MunicipioDto) =>
                `${item.nomeMunicipio} - ${item.ufMunicipio}`
              }
              getId={(item: MunicipioDto) => item.codigoMunicipio}
              registeredFields={{
                id: form.register("codigoMunicipioInicio"),
                description: form.register("nomeMunicipioInicio"),
              }}
              errorsMessageDescription={
                form.formState.errors.codigoMunicipioInicio
              }
              onSelect={(item: MunicipioDto | undefined) => {
                if (item) {
                  form.setValue("codigoMunicipioInicio", item.codigoMunicipio);
                  form.setValue("nomeMunicipioInicio", item.nomeMunicipio);
                  form.setValue("ufInicio", item.ufMunicipio);
                } else {
                  form.setValue("codigoMunicipioInicio", 0);
                  form.setValue("nomeMunicipioInicio", "");
                  form.setValue("ufInicio", "");
                }
              }}
            />
          </Col>
          <Col xs={12} md={3}>
            <FloatInput
              label="UF Início"
              registerField={form.register("ufInicio")}
              errorsMessage={form.formState.errors.ufInicio}
              readOnly={true}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-4">
        <h5 className="mb-3 text-primary">Fim da Prestação (Término)</h5>
        <Row className="g-3">
          <Col xs={12} md={9}>
            <DropdownFilter<MunicipioDto>
              fetchData={consultaMunicipioFim.MunicipioBuscar}
              loading={consultaMunicipioFim.loading}
              labelDescription="Município de Término"
              getDescription={(item: MunicipioDto) =>
                `${item.nomeMunicipio} - ${item.ufMunicipio}`
              }
              getId={(item: MunicipioDto) => item.codigoMunicipio}
              registeredFields={{
                id: form.register("codigoMunicipioFim"),
                description: form.register("nomeMunicipioFim"),
              }}
              errorsMessageDescription={
                form.formState.errors.codigoMunicipioFim
              }
              onSelect={(item: MunicipioDto | undefined) => {
                if (item) {
                  form.setValue("codigoMunicipioFim", item.codigoMunicipio);
                  form.setValue("nomeMunicipioFim", item.nomeMunicipio);
                  form.setValue("ufFim", item.ufMunicipio);
                } else {
                  form.setValue("codigoMunicipioFim", 0);
                  form.setValue("nomeMunicipioFim", "");
                  form.setValue("ufFim", "");
                }
              }}
            />
          </Col>
          <Col xs={12} md={3}>
            <FloatInput
              label="UF Fim"
              registerField={form.register("ufFim")}
              errorsMessage={form.formState.errors.ufFim}
              readOnly={true}
            />
          </Col>
        </Row>
      </div>

      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar}>
                Voltar
              </Button>
            </Col>
            <Col xs={6} className="d-grid">
              <Button variant="outline-primary" type="submit">
                Próximo
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </Form>
  );
};

export default CTeCadastroPercursoView;
